var _defs, _rect, _rect2, _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg9(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 100,
    zoomAndPan: "magnify",
    viewBox: "0 0 75 74.999997",
    height: 100,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a39a7fa03e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1.023438 0 L 73.773438 0 L 73.773438 72.75 L 1.023438 72.75 Z M 1.023438 0 ",
    clipRule: "nonzero"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -7.5,
    width: 90,
    fill: "#ffffff",
    y: -7.5,
    height: 89.999996,
    fillOpacity: 1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -7.5,
    width: 90,
    fill: "#ffffff",
    y: -7.5,
    height: 89.999996,
    fillOpacity: 1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#441f39",
    d: "M 33.015625 55.40625 C 33.015625 52.753906 34.914062 50.839844 37.496094 50.839844 C 40.230469 50.839844 41.976562 52.753906 41.976562 55.40625 C 41.976562 57.980469 40.230469 59.96875 37.496094 59.96875 C 34.835938 59.96875 33.015625 57.980469 33.015625 55.40625 Z M 34.574219 44.308594 L 32.464844 18.097656 C 32.359375 16.785156 34.664062 15.71875 37.496094 15.71875 C 40.328125 15.71875 42.628906 16.792969 42.527344 18.097656 L 40.417969 44.308594 C 40.34375 45.195312 39.0625 45.898438 37.496094 45.898438 C 35.933594 45.898438 34.648438 45.195312 34.574219 44.308594 Z M 34.574219 44.308594 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a39a7fa03e)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 37.496094 72.945312 C 17.382812 72.945312 1.023438 56.585938 1.023438 36.472656 C 1.023438 16.363281 17.382812 0 37.496094 0 C 57.605469 0 73.96875 16.363281 73.96875 36.472656 C 73.96875 56.585938 57.605469 72.945312 37.496094 72.945312 Z M 37.496094 6.21875 C 20.8125 6.21875 7.242188 19.789062 7.242188 36.472656 C 7.242188 53.15625 20.8125 66.726562 37.496094 66.726562 C 54.179688 66.726562 67.75 53.15625 67.75 36.472656 C 67.75 19.789062 54.179688 6.21875 37.496094 6.21875 Z M 37.496094 6.21875 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg9);
export default __webpack_public_path__ + "static/media/9.d1e67bd3c10b7e7e8d89515458667c41.svg";
export { ForwardRef as ReactComponent };